// Styled Components

import { styled } from "styled-components";

export const BackButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 20px;
`;
export const DaysList = styled.div`
  margin: 12px 0 0 0;
  width: 100%
`;
export const DayRow = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.colors.underline};
  padding: 10px 0px;
  @media (max-width: 600px) {
    padding: 10px 0px;
  }
`;
export const DayName = styled.div`
  font-weight: 600;
  font-size: 1rem;
`;
export const RowContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

export const RowContentWrapper = styled.div`
  display: flex;
  align-items: center;
  width:100%;
  justify-content: space-between;
`;

export const StatusLabel = styled.div`
  font-size: 0.95rem;
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.darkGray};
`;
export const TimeBlock = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.gray : theme.colors.secondaryText};
  font-size: 1.05rem;
  margin-left: auto;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  text-align: right;
  cursor:pointer;
`;
// Modal
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
export const ModalContent = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 28px 18px 18px 18px;
  min-width: 260px;
  max-width: 94vw;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ModalKYBContent = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 28px 18px 18px 18px;
  width: 900px;
  height: calc(100% - 64px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  @media (max-width: 767px) {
     width: calc(100% - 32px);
  height: calc(100% - 64px);
  }
    `;
export const ModalTitle = styled.div`
  font-size: 1.12rem;
  font-weight: 600;
  margin-bottom: 18px;
`;
export const ModalLabel = styled.div`
  font-size: 0.98rem;
  color: ${({ theme }) => theme.colors.darkGray};
  margin-bottom: 4px;
  margin-top: 12px;
`;
export const TimeInput = styled.input<{ $customStyle?: boolean }>`
  width: 100%;
  max-width: 680px;
  padding: 8px 14px;
  font-size: 1rem;
  border: 1.5px solid ${({ theme, $customStyle }) => 
    $customStyle ? '#E39435' : theme.colors.lightGray};
  border-radius: ${({ $customStyle }) => $customStyle ? '4px' : '8px'};
  height: ${({ $customStyle }) => $customStyle ? '56px' : 'auto'};
  margin-bottom: 4px;
`;
export const ModalSaveButton = styled.button`
  background: ${({ theme }) => theme.colors.secondary};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 1rem;
  font-weight: 500;
  margin-top: 18px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: ${({ theme }) => theme.colors.secondaryDark};
  }
`;
export const ErrorText = styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 0.95rem;
  margin-top: 4px;
  margin-bottom: 2px;
  text-align: center;
`;